// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-details-overlay {
  --ud-ink: #1f1b2e;
  --ud-muted: #55515f;
  --ud-soft: #6f7588;
  --ud-lavender: #d5d1fd;
  --ud-panel: #f7f6fa;
  --ud-surface: #ffffff;
  --ud-line: rgba(31, 27, 46, 0.1);
  --ud-radius: 20px;

  position: fixed;
  inset: 0;
  z-index: 1190;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(18, 16, 26, 0.48);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.user-details-dialog {
  display: flex;
  flex-direction: column;
  width: min(100%, 1320px);
  height: min(98vh, 1200px);
  max-height: min(98vh, 1200px);
  margin: auto;
  background: var(--ud-surface);
  color: var(--ud-ink);
  border: 1px solid var(--ud-line);
  border-radius: var(--ud-radius);
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);
  overflow: hidden;
}

.user-details-dialog__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.6rem 1.15rem;
  border-bottom: 1px solid var(--ud-line);
  flex-shrink: 0;
  background: var(--ud-surface);
}

.user-details-dialog__eyebrow {
  margin: 0 0 0.3rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ud-muted);
}

.user-details-dialog__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.55rem, 2.4vw, 1.95rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--ud-ink);
}

.user-details-dialog__lead {
  margin: 0.55rem 0 0;
  font-size: 1.02rem;
  line-height: 1.45;
  color: var(--ud-muted);
  white-space: nowrap;
}

.user-details-dialog__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.35rem;
  height: 2.35rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 999px;
  background: var(--ud-panel);
  color: var(--ud-ink);
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.user-details-dialog__close:hover:not(:disabled) {
  background: #ebe8f2;
}

.user-details-dialog__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.user-details-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.user-details-form__scroll {
  flex: 1 1;
  min-height: 0;
  padding: 1.2rem 1.6rem 1.4rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
  display: flex;
  flex-direction: column;
  gap: 1.45rem;
}

.user-details-block__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-bottom: 0.85rem;
}

.user-details-block__title {
  margin: 0 0 0.45rem;
  font-size: 0.84rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ud-soft);
}

.user-details-block__head .user-details-block__title {
  margin-bottom: 0;
}

.user-details-block__hint {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--ud-muted);
}

.user-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.95rem 1rem;
}

.user-details-location {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: end;
  gap: 0.65rem 0.55rem;
  margin-bottom: 1.15rem;
}

.user-details-location__step {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
  padding: 0.85rem 0.9rem 0.95rem;
  border-radius: 14px;
  border: 1px solid var(--ud-line);
  background: #fbfbfd;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.user-details-location__step.is-current {
  background: rgba(213, 209, 253, 0.22);
  border-color: rgba(213, 209, 253, 0.95);
  box-shadow: 0 0 0 1px rgba(213, 209, 253, 0.45);
}

.user-details-location__step.is-done {
  background: rgba(191, 241, 219, 0.22);
  border-color: rgba(191, 241, 219, 0.9);
}

.user-details-location__step.is-locked {
  background: var(--ud-panel);
  opacity: 0.72;
}

.user-details-location__meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-details-location__index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 8px;
  background: var(--ud-panel);
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--ud-soft);
  flex-shrink: 0;
}

.user-details-location__step.is-current .user-details-location__index {
  background: var(--ud-lavender);
  color: #3a3560;
}

.user-details-location__step.is-done .user-details-location__index {
  background: rgba(191, 241, 219, 0.95);
  color: #2a5a45;
}

.user-details-location__connector {
  width: 1.1rem;
  height: 2px;
  margin-bottom: 1.45rem;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(213, 209, 253, 0.95),
    rgba(191, 241, 219, 0.85)
  );
  align-self: end;
}

.user-details-field--address {
  margin-top: 0.15rem;
}

.user-details-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
  padding: 0.85rem 0.9rem 0.95rem;
  border-radius: 14px;
  border: 1px solid transparent;
  background: transparent;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.user-details-field.is-done {
  background: rgba(191, 241, 219, 0.22);
  border-color: rgba(191, 241, 219, 0.9);
}

.user-details-field--span2 {
  grid-column: 1 / -1;
}

.user-details-field__label {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ud-ink);
}

.user-details-field__hint {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--ud-soft);
}

.user-details-email {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: flex-end;
  gap: 0.35rem 0.55rem;
  margin: 0;
  min-width: 0;
  text-align: right;
}

.user-details-email__label {
  font-size: 0.84rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ud-soft);
}

.user-details-email__value {
  font-size: 1.02rem;
  font-weight: 600;
  color: var(--ud-ink);
  word-break: break-all;
}

.user-details-field__error {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: #a33b3b;
}

.user-details-input {
  width: 100%;
  padding: 0.75rem 0.9rem;
  border-radius: 10px;
  border: 1px solid rgba(143, 155, 175, 0.28);
  background: var(--ud-surface);
  color: var(--ud-ink);
  font-size: 1rem;
  line-height: 1.45;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.user-details-input:focus {
  outline: 2px solid rgba(31, 27, 46, 0.25);
  outline-offset: 1px;
  border-color: rgba(31, 27, 46, 0.28);
}

.user-details-input:disabled {
  background: var(--ud-panel);
  color: var(--ud-muted);
  cursor: not-allowed;
}

.user-details-phone .react-tel-input {
  width: 100%;
}

.user-details-phone .react-tel-input .form-control {
  width: 100% !important;
  height: 2.9rem;
  padding-left: 3.4rem !important;
  border-radius: 10px;
  border: 1px solid rgba(143, 155, 175, 0.28);
  background: var(--ud-surface);
  color: var(--ud-ink);
  font-size: 1rem;
  box-shadow: none;
}

.user-details-phone .react-tel-input .form-control:focus {
  outline: 2px solid rgba(31, 27, 46, 0.25);
  outline-offset: 1px;
  border-color: rgba(31, 27, 46, 0.28);
  box-shadow: none;
}

.user-details-phone .react-tel-input .flag-dropdown {
  border: 1px solid rgba(143, 155, 175, 0.28);
  border-radius: 10px 0 0 10px;
  background: var(--ud-panel);
}

.user-details-phone .react-tel-input .selected-flag {
  border-radius: 10px 0 0 10px;
  width: 3rem;
  padding: 0 0 0 0.65rem;
}

.user-details-phone .react-tel-input .flag-dropdown.open,
.user-details-phone .react-tel-input .flag-dropdown.open .selected-flag,
.user-details-phone .react-tel-input .selected-flag:hover,
.user-details-phone .react-tel-input .selected-flag:focus {
  background: #ebe8f2;
}

.user-details-phone .react-tel-input .country-list {
  border-radius: 12px;
  border: 1px solid var(--ud-line);
  box-shadow: 0 12px 28px rgba(18, 16, 26, 0.16);
}

.user-details-select__control {
  min-height: 2.9rem !important;
  border-radius: 10px !important;
  border-color: rgba(143, 155, 175, 0.28) !important;
  box-shadow: none !important;
  background: var(--ud-surface) !important;
}

.user-details-select__control--is-focused {
  border-color: rgba(31, 27, 46, 0.28) !important;
  box-shadow: 0 0 0 2px rgba(31, 27, 46, 0.25) !important;
}

.user-details-select__control--is-disabled {
  background: #efedf3 !important;
  border-color: rgba(143, 155, 175, 0.18) !important;
  cursor: not-allowed;
}

.user-details-location__step.is-locked .user-details-select__placeholder {
  color: #8a8794 !important;
}

.user-details-select__value-container {
  padding: 0.2rem 0.7rem !important;
}

.user-details-select__placeholder,
.user-details-select__single-value {
  font-size: 1rem;
  color: var(--ud-ink);
}

.user-details-select__placeholder {
  color: var(--ud-soft) !important;
}

.user-details-select__indicator-separator {
  display: none;
}

.user-details-select__menu {
  border-radius: 12px !important;
  border: 1px solid var(--ud-line);
  box-shadow: 0 12px 28px rgba(18, 16, 26, 0.16) !important;
  overflow: hidden;
  z-index: 5 !important;
}

.user-details-select__option--is-focused {
  background: var(--ud-panel) !important;
}

.user-details-select__option--is-selected {
  background: rgba(213, 209, 253, 0.55) !important;
  color: var(--ud-ink) !important;
}

.user-details-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  padding: 0.95rem 1.6rem 1.15rem;
  border-top: 1px solid var(--ud-line);
  background: var(--ud-surface);
  flex-shrink: 0;
}

.user-details-footer__note {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--ud-soft);
}

.user-details-footer__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-left: auto;
}

.user-details-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 2.75rem;
  padding: 0.7rem 1.25rem;
  border-radius: 10px;
  font-weight: 750;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.user-details-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.user-details-btn--ghost {
  border: 1px solid var(--ud-line);
  background: var(--ud-panel);
  color: var(--ud-ink);
}

.user-details-btn--ghost:hover:not(:disabled) {
  background: #ebe8f2;
}

.user-details-btn--primary {
  border: 1px solid rgba(139, 132, 216, 0.4);
  background: var(--ud-lavender);
  color: #3a3560;
}

.user-details-btn--primary:hover:not(:disabled) {
  background: #d5d1fd;
  border-color: rgba(139, 132, 216, 0.6);
}

@media (max-width: 820px) {
  .user-details-location {
    grid-template-columns: 1fr;
    gap: 0.55rem;
  }

  .user-details-location__connector {
    width: 2px;
    height: 0.7rem;
    margin: 0 auto;
    background: linear-gradient(
      180deg,
      rgba(213, 209, 253, 0.95),
      rgba(191, 241, 219, 0.85)
    );
  }
}

@media (max-width: 900px) {
  .user-details-dialog__lead {
    white-space: normal;
  }
}

@media (max-width: 640px) {
  .user-details-block__head {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .user-details-email {
    justify-content: flex-start;
    text-align: left;
  }

  .user-details-overlay {
    padding: 0.75rem;
  }

  .user-details-dialog {
    height: min(97vh, 1080px);
    max-height: min(97vh, 1080px);
    border-radius: 16px;
  }

  .user-details-dialog__top,
  .user-details-form__scroll,
  .user-details-footer {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .user-details-grid {
    grid-template-columns: 1fr;
  }

  .user-details-field--span2 {
    grid-column: auto;
  }

  .user-details-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .user-details-footer__nav {
    margin-left: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .user-details-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,iBAAiB;;EAEjB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,uCAAuC;EACvC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB;;;;GAIC;EACD,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kDAAkD;EAClD,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yDAAyD;EACzD,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,UAAU;IACV,cAAc;IACd,cAAc;IACd;;;;KAIC;EACH;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".user-details-overlay {\n  --ud-ink: #1f1b2e;\n  --ud-muted: #55515f;\n  --ud-soft: #6f7588;\n  --ud-lavender: #d5d1fd;\n  --ud-panel: #f7f6fa;\n  --ud-surface: #ffffff;\n  --ud-line: rgba(31, 27, 46, 0.1);\n  --ud-radius: 20px;\n\n  position: fixed;\n  inset: 0;\n  z-index: 1190;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(18, 16, 26, 0.48);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.user-details-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 1320px);\n  height: min(98vh, 1200px);\n  max-height: min(98vh, 1200px);\n  margin: auto;\n  background: var(--ud-surface);\n  color: var(--ud-ink);\n  border: 1px solid var(--ud-line);\n  border-radius: var(--ud-radius);\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.24);\n  overflow: hidden;\n}\n\n.user-details-dialog__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.25rem 1.6rem 1.15rem;\n  border-bottom: 1px solid var(--ud-line);\n  flex-shrink: 0;\n  background: var(--ud-surface);\n}\n\n.user-details-dialog__eyebrow {\n  margin: 0 0 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ud-muted);\n}\n\n.user-details-dialog__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.55rem, 2.4vw, 1.95rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--ud-ink);\n}\n\n.user-details-dialog__lead {\n  margin: 0.55rem 0 0;\n  font-size: 1.02rem;\n  line-height: 1.45;\n  color: var(--ud-muted);\n  white-space: nowrap;\n}\n\n.user-details-dialog__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.35rem;\n  height: 2.35rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 999px;\n  background: var(--ud-panel);\n  color: var(--ud-ink);\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.user-details-dialog__close:hover:not(:disabled) {\n  background: #ebe8f2;\n}\n\n.user-details-dialog__close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.user-details-form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.user-details-form__scroll {\n  flex: 1 1 0%;\n  min-height: 0;\n  padding: 1.2rem 1.6rem 1.4rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-gutter: stable;\n  display: flex;\n  flex-direction: column;\n  gap: 1.45rem;\n}\n\n.user-details-block__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem 1.25rem;\n  margin-bottom: 0.85rem;\n}\n\n.user-details-block__title {\n  margin: 0 0 0.45rem;\n  font-size: 0.84rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ud-soft);\n}\n\n.user-details-block__head .user-details-block__title {\n  margin-bottom: 0;\n}\n\n.user-details-block__hint {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--ud-muted);\n}\n\n.user-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.95rem 1rem;\n}\n\n.user-details-location {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: end;\n  gap: 0.65rem 0.55rem;\n  margin-bottom: 1.15rem;\n}\n\n.user-details-location__step {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-width: 0;\n  padding: 0.85rem 0.9rem 0.95rem;\n  border-radius: 14px;\n  border: 1px solid var(--ud-line);\n  background: #fbfbfd;\n  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.user-details-location__step.is-current {\n  background: rgba(213, 209, 253, 0.22);\n  border-color: rgba(213, 209, 253, 0.95);\n  box-shadow: 0 0 0 1px rgba(213, 209, 253, 0.45);\n}\n\n.user-details-location__step.is-done {\n  background: rgba(191, 241, 219, 0.22);\n  border-color: rgba(191, 241, 219, 0.9);\n}\n\n.user-details-location__step.is-locked {\n  background: var(--ud-panel);\n  opacity: 0.72;\n}\n\n.user-details-location__meta {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.user-details-location__index {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 8px;\n  background: var(--ud-panel);\n  font-size: 0.72rem;\n  font-weight: 800;\n  color: var(--ud-soft);\n  flex-shrink: 0;\n}\n\n.user-details-location__step.is-current .user-details-location__index {\n  background: var(--ud-lavender);\n  color: #3a3560;\n}\n\n.user-details-location__step.is-done .user-details-location__index {\n  background: rgba(191, 241, 219, 0.95);\n  color: #2a5a45;\n}\n\n.user-details-location__connector {\n  width: 1.1rem;\n  height: 2px;\n  margin-bottom: 1.45rem;\n  border-radius: 999px;\n  background: linear-gradient(\n    90deg,\n    rgba(213, 209, 253, 0.95),\n    rgba(191, 241, 219, 0.85)\n  );\n  align-self: end;\n}\n\n.user-details-field--address {\n  margin-top: 0.15rem;\n}\n\n.user-details-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 0;\n  padding: 0.85rem 0.9rem 0.95rem;\n  border-radius: 14px;\n  border: 1px solid transparent;\n  background: transparent;\n  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.user-details-field.is-done {\n  background: rgba(191, 241, 219, 0.22);\n  border-color: rgba(191, 241, 219, 0.9);\n}\n\n.user-details-field--span2 {\n  grid-column: 1 / -1;\n}\n\n.user-details-field__label {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ud-ink);\n}\n\n.user-details-field__hint {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--ud-soft);\n}\n\n.user-details-email {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 0.35rem 0.55rem;\n  margin: 0;\n  min-width: 0;\n  text-align: right;\n}\n\n.user-details-email__label {\n  font-size: 0.84rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ud-soft);\n}\n\n.user-details-email__value {\n  font-size: 1.02rem;\n  font-weight: 600;\n  color: var(--ud-ink);\n  word-break: break-all;\n}\n\n.user-details-field__error {\n  margin: 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: #a33b3b;\n}\n\n.user-details-input {\n  width: 100%;\n  padding: 0.75rem 0.9rem;\n  border-radius: 10px;\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  background: var(--ud-surface);\n  color: var(--ud-ink);\n  font-size: 1rem;\n  line-height: 1.45;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.user-details-input:focus {\n  outline: 2px solid rgba(31, 27, 46, 0.25);\n  outline-offset: 1px;\n  border-color: rgba(31, 27, 46, 0.28);\n}\n\n.user-details-input:disabled {\n  background: var(--ud-panel);\n  color: var(--ud-muted);\n  cursor: not-allowed;\n}\n\n.user-details-phone .react-tel-input {\n  width: 100%;\n}\n\n.user-details-phone .react-tel-input .form-control {\n  width: 100% !important;\n  height: 2.9rem;\n  padding-left: 3.4rem !important;\n  border-radius: 10px;\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  background: var(--ud-surface);\n  color: var(--ud-ink);\n  font-size: 1rem;\n  box-shadow: none;\n}\n\n.user-details-phone .react-tel-input .form-control:focus {\n  outline: 2px solid rgba(31, 27, 46, 0.25);\n  outline-offset: 1px;\n  border-color: rgba(31, 27, 46, 0.28);\n  box-shadow: none;\n}\n\n.user-details-phone .react-tel-input .flag-dropdown {\n  border: 1px solid rgba(143, 155, 175, 0.28);\n  border-radius: 10px 0 0 10px;\n  background: var(--ud-panel);\n}\n\n.user-details-phone .react-tel-input .selected-flag {\n  border-radius: 10px 0 0 10px;\n  width: 3rem;\n  padding: 0 0 0 0.65rem;\n}\n\n.user-details-phone .react-tel-input .flag-dropdown.open,\n.user-details-phone .react-tel-input .flag-dropdown.open .selected-flag,\n.user-details-phone .react-tel-input .selected-flag:hover,\n.user-details-phone .react-tel-input .selected-flag:focus {\n  background: #ebe8f2;\n}\n\n.user-details-phone .react-tel-input .country-list {\n  border-radius: 12px;\n  border: 1px solid var(--ud-line);\n  box-shadow: 0 12px 28px rgba(18, 16, 26, 0.16);\n}\n\n.user-details-select__control {\n  min-height: 2.9rem !important;\n  border-radius: 10px !important;\n  border-color: rgba(143, 155, 175, 0.28) !important;\n  box-shadow: none !important;\n  background: var(--ud-surface) !important;\n}\n\n.user-details-select__control--is-focused {\n  border-color: rgba(31, 27, 46, 0.28) !important;\n  box-shadow: 0 0 0 2px rgba(31, 27, 46, 0.25) !important;\n}\n\n.user-details-select__control--is-disabled {\n  background: #efedf3 !important;\n  border-color: rgba(143, 155, 175, 0.18) !important;\n  cursor: not-allowed;\n}\n\n.user-details-location__step.is-locked .user-details-select__placeholder {\n  color: #8a8794 !important;\n}\n\n.user-details-select__value-container {\n  padding: 0.2rem 0.7rem !important;\n}\n\n.user-details-select__placeholder,\n.user-details-select__single-value {\n  font-size: 1rem;\n  color: var(--ud-ink);\n}\n\n.user-details-select__placeholder {\n  color: var(--ud-soft) !important;\n}\n\n.user-details-select__indicator-separator {\n  display: none;\n}\n\n.user-details-select__menu {\n  border-radius: 12px !important;\n  border: 1px solid var(--ud-line);\n  box-shadow: 0 12px 28px rgba(18, 16, 26, 0.16) !important;\n  overflow: hidden;\n  z-index: 5 !important;\n}\n\n.user-details-select__option--is-focused {\n  background: var(--ud-panel) !important;\n}\n\n.user-details-select__option--is-selected {\n  background: rgba(213, 209, 253, 0.55) !important;\n  color: var(--ud-ink) !important;\n}\n\n.user-details-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.65rem;\n  padding: 0.95rem 1.6rem 1.15rem;\n  border-top: 1px solid var(--ud-line);\n  background: var(--ud-surface);\n  flex-shrink: 0;\n}\n\n.user-details-footer__note {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--ud-soft);\n}\n\n.user-details-footer__nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.65rem;\n  margin-left: auto;\n}\n\n.user-details-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.25rem;\n  border-radius: 10px;\n  font-weight: 750;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.user-details-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.user-details-btn--ghost {\n  border: 1px solid var(--ud-line);\n  background: var(--ud-panel);\n  color: var(--ud-ink);\n}\n\n.user-details-btn--ghost:hover:not(:disabled) {\n  background: #ebe8f2;\n}\n\n.user-details-btn--primary {\n  border: 1px solid rgba(139, 132, 216, 0.4);\n  background: var(--ud-lavender);\n  color: #3a3560;\n}\n\n.user-details-btn--primary:hover:not(:disabled) {\n  background: #d5d1fd;\n  border-color: rgba(139, 132, 216, 0.6);\n}\n\n@media (max-width: 820px) {\n  .user-details-location {\n    grid-template-columns: 1fr;\n    gap: 0.55rem;\n  }\n\n  .user-details-location__connector {\n    width: 2px;\n    height: 0.7rem;\n    margin: 0 auto;\n    background: linear-gradient(\n      180deg,\n      rgba(213, 209, 253, 0.95),\n      rgba(191, 241, 219, 0.85)\n    );\n  }\n}\n\n@media (max-width: 900px) {\n  .user-details-dialog__lead {\n    white-space: normal;\n  }\n}\n\n@media (max-width: 640px) {\n  .user-details-block__head {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n\n  .user-details-email {\n    justify-content: flex-start;\n    text-align: left;\n  }\n\n  .user-details-overlay {\n    padding: 0.75rem;\n  }\n\n  .user-details-dialog {\n    height: min(97vh, 1080px);\n    max-height: min(97vh, 1080px);\n    border-radius: 16px;\n  }\n\n  .user-details-dialog__top,\n  .user-details-form__scroll,\n  .user-details-footer {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .user-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .user-details-field--span2 {\n    grid-column: auto;\n  }\n\n  .user-details-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .user-details-footer__nav {\n    margin-left: 0;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .user-details-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
